import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import { IconButton } from '@mui/material';

const actionsStyles = theme => ({
	root: {
		flexShrink: 0,
		color: theme.palette.text.secondary,
		marginLeft: theme.spacing(2.5),
	},
});

class TablePaginationActions extends React.Component {

	handleFirstPageButtonClick = event => {
		this.props.onPageChange(event, 0)
	}

	handleBackButtonClick = event => {
		this.props.onPageChange(event, this.props.page - 1)
	}

	handleNextButtonClick = event => {
		this.props.onPageChange(event, this.props.page + 1)
	}

	handleLastPageButtonClick = event => {
		this.props.onPageChange(
			event, 
			Math.max(0, Math.ceil(this.props.count / parseInt(this.props.rowsPerPage)) - 1),
		)
	}
	
	render() {
		const { classes, count, page, rowsPerPage } = this.props;
        // console.log("PROPS", this.props)
		let rows = parseInt(rowsPerPage)
		return (
            <div className={classes.root}>
				<IconButton
                    color="secondary"
                    onClick={this.handleFirstPageButtonClick}
                    disabled={page === 0}
                    aria-label="Première Page"
                    size="large">
					{<FirstPageIcon />}
				</IconButton>
				<IconButton
                    color="secondary"
                    onClick={this.handleBackButtonClick}
                    disabled={page === 0}
                    aria-label="Précédent"
                    size="large">
					{<KeyboardArrowLeft />}
				</IconButton>
				<IconButton
                    color="secondary"
                    onClick={this.handleNextButtonClick}
                    disabled={page >= Math.ceil(count / rows) - 1}
                    aria-label="Suivant"
                    size="large">
					{<KeyboardArrowRight />}
				</IconButton>
				<IconButton
                    color="secondary"
                    onClick={this.handleLastPageButtonClick}
                    disabled={page >= Math.ceil(count / rows) - 1}
                    aria-label="Dernière Page"
                    size="large">
					{<LastPageIcon />}
				</IconButton>
			</div>
        );
	}
}

TablePaginationActions.propTypes = {
	classes: PropTypes.object.isRequired,
	count: PropTypes.number.isRequired,
	onPageChange: PropTypes.func.isRequired,
	page: PropTypes.number.isRequired,
	rowsPerPage: PropTypes.number.isRequired,
	theme: PropTypes.object.isRequired,
};

const Pagination = withStyles(actionsStyles, { withTheme: true })(
	TablePaginationActions,
);
export default Pagination;
